import { render, staticRenderFns } from "./ApplicationUriDetails.vue?vue&type=template&id=9b053324&"
import script from "./ApplicationUriDetails.vue?vue&type=script&lang=js&"
export * from "./ApplicationUriDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports